module.exports = __webpack_public_path__ + "img/bolaDelMundo.a34c0913.jpg";